import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import Dashboard from '../paginas/Dashboard/Dashboard';
import Login from '../paginas/Login/Login';
import PedidosList from '../paginas/Pedidos/PedidosList';
import ClientesList from '../paginas/Clientes/ClientesList';
import AprovarClientesList from '../paginas/AprovarClientes/AprovarClientesList';
import AprovarClientesEdit from '../paginas/AprovarClientes/AprovarClientesEdit';
import AprovarClientesDetalhes from '../paginas/AprovarClientes/AprovarClientesDetalhes';

import { RotaProtegida } from './RotaProtegida';
import ListaComunicados from '../paginas/Comunicados/ListaComunicados';
import EditarComunicado from '../paginas/Comunicados/EditarComunicado';
import ListaPerfisAcesso from '../paginas/PerfisAcesso/ListaPerfisAcesso';

export function AppRoutes() {
  const token = localStorage.getItem('token');

  return (
    <Routes>
      {/* Redireciona raiz para login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Se já estiver logado, não deixa ir pro login */}
      <Route
        path="/login"
        element={token ? <Navigate to="/dashboard" replace /> : <Login />}
      />

      {/* Rotas protegidas */}
      <Route
        path="/dashboard"
        element={
          <RotaProtegida>
            <Dashboard />
          </RotaProtegida>
        }
      />
      <Route
        path="/pedidos"
        element={
          <RotaProtegida>
            <PedidosList />
          </RotaProtegida>
        }
      />
      <Route
        path="/clientes"
        element={
          <RotaProtegida>
            <ClientesList />
          </RotaProtegida>
        }
      />
      <Route
        path="/aprovar-clientes"
        element={
          <RotaProtegida>
            <AprovarClientesList />
          </RotaProtegida>
        }
      />
      <Route
        path="/aprovar-cliente/editar/:id"
        element={
          <RotaProtegida>
            <AprovarClientesEdit />
          </RotaProtegida>
        }
      />
      <Route
        path="/aprovar-cliente/detalhes/:id"
        element={
          <RotaProtegida>
            <AprovarClientesDetalhes />
          </RotaProtegida>
        }
      />

      <Route
        path="/comunicados"
        element={
          <RotaProtegida>
            <ListaComunicados />
          </RotaProtegida>
        }
      />

      <Route
        path="/comunicado/editar/:id"
        element={
          <RotaProtegida>
            <EditarComunicado />
          </RotaProtegida>
        }
      />

      <Route
        path="/perfis-acesso"
        element={
          <RotaProtegida>
            <ListaPerfisAcesso />
          </RotaProtegida>
        }
      />

      {/* Fallback para rotas inexistentes */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
}
